module.exports = __webpack_public_path__ + "media/luxury-2026/location-green-study-960-d18d79dd.jpg";